<template>
    <div>
        <TheHeader class="mob-header" />
        <BaseTitle :infor="infor" />
        <div class="banner">
            <img :src="banner">
        </div>
        <BaseArcticle :list="infor.list" />
        <AboutUsPhoto :list="member" />
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseArcticle from '@/components/module/BaseArcticle'
    import AboutUsPhoto from '@/components/module/AboutUsPhoto'

    export default {
        name: 'MobAboutUs',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseArcticle,
            AboutUsPhoto
        },
        computed: {
            member: function(){
                let infor = JSON.parse(JSON.stringify(this.infor));
                let arr = infor.member;
                let l = arr.length;
                let n = 3-l%3;
                for( let i = 0; i<n; i++ ){
                    let Obj = {
                        id: (l+i+1),
                        name: '',
                        post: '',
                        photo: ''
                    };
                    arr.push(Obj);
                }
                return arr;
            },
            banner: function(){
                let banner = this.infor.mobbanner;
                return banner;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-box {
    padding-bottom: .32rem;
}
.detail-acticle {
    padding-top: .533rem;
}

</style>